import React from 'react';
import { GymMinimalProps } from '../../constants/types';
import Modal from '../UI/ModalRoute';
import CustomButton from '../UI/CustomButton';
import { TailSpin } from 'react-loader-spinner';

interface GymSelectionModalProps {
    isOpen: boolean;
    onClose: () => void;
    gymsFilterInfo: GymMinimalProps[] | undefined;
    currentGym: GymMinimalProps | null;
    onGymSelect: (gym: GymMinimalProps) => void;
}

const GymSelectionModal: React.FC<GymSelectionModalProps> = ({
    isOpen,
    onClose,
    gymsFilterInfo,
    currentGym,
    onGymSelect,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} titleModal="Choix salle" position='relative' width='fit-content'>
            <div className="gym-list">
                {gymsFilterInfo ?
                    gymsFilterInfo.map((gym) => (
                        <CustomButton
                            key={gym.id}
                            customStyle={currentGym && gym.id === currentGym.id ? "select-gym-button" : "select-gym-button-inactive"}
                            onClickProp={() => onGymSelect(gym)}
                            text={gym.name}
                            customTextStyle='bold large2'
                        />
                    ))
                    :
                    <div style={{alignSelf: 'center'}}>
                        <TailSpin color="#0099CC" height={80} width={80} />
                    </div>
                }
            </div>
        </Modal>
    );
};

export default GymSelectionModal;
